"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_2 = require("@osmosys/react");
const Shell_1 = require("./Shell");
exports.BlockCanvasInner = ({ children, isChildBlock, isLast, blockName, isFirst }) => {
    return (react_1.default.createElement(react_2.OsmosysDiv, { marginTop: !isChildBlock, marginBottom: !isChildBlock && isLast, marginRight: !isChildBlock, marginLeft: !isChildBlock, flexColFilled: !!(isLast && isFirst) || isLast, "data-block-name": blockName },
        react_1.default.createElement(react_2.OsmosysDiv, { className: "position-relative", flexColFilled: true },
            children,
            react_1.default.createElement(Shell_1.BlockCanvasShell, null))));
};
//# sourceMappingURL=Inner.js.map